/**  @typedef {import('./Props').default} Props */

import { translate } from '../../../../App/Internationalization';
import ActionMessage from '../../../ActionMessages/ActionMessage';
import React from 'react';

/** @extends React.Component<Props> */
export default class AgentBulkInvitePopup extends React.Component {
	/** @returns {JSX.Element} */
	render() {
		//translate message according to selcected bulk action
		let messageKey = 'admin.pages.agents.invite.popup.bulk_invite';
		if (this.props.selectedOption === 'bulk_active') {
			messageKey = 'admin.pages.agents.invite.popup.bulk_active';
		} else if (this.props.selectedOption === 'bulk_disable') {
			messageKey = 'admin.pages.agents.invite.popup.bulk_disable';
		}

		return (
			<ActionMessage
				action="warning"
				onClose={this.props.onClose}
				onSubmit={this.props.onSubmit}
				title={translate('agent.pages.contacts.popup.header')}
			>
				<section>
					{translate(
						messageKey,
						this.props.selectedAgents?.length.toString()
					)}
				</section>
			</ActionMessage>
		);
	}
}
